// Shared Merchant/Offer structured-data values — single source of truth for
// prerender-seo.js (Node/CommonJS) AND SEOHead.js / BundleDetail.js (CRA/ESM).
// Authored as CommonJS so `require()` works in the prerender build; CRA imports
// it via interop. Keep this file plain data + pure functions (no JSX, no deps).

// Published shipping policy (/policies): R100 flat, ZA only, 1-2 day handling, 3-5 day transit.
// Deliberately NOT encoding the R1,000 cart-level free-shipping threshold or local collection.
const SHIPPING_DETAILS = {
  "@type": "OfferShippingDetails",
  shippingRate: { "@type": "MonetaryAmount", value: "100.00", currency: "ZAR" },
  shippingDestination: { "@type": "DefinedRegion", addressCountry: "ZA" },
  deliveryTime: {
    "@type": "ShippingDeliveryTime",
    handlingTime: { "@type": "QuantitativeValue", minValue: 1, maxValue: 2, unitCode: "DAY" },
    transitTime: { "@type": "QuantitativeValue", minValue: 3, maxValue: 5, unitCode: "DAY" },
  },
};

// Standard 7-day finite return policy (matches /policies for returnable goods).
const STANDARD_RETURN_POLICY = {
  "@type": "MerchantReturnPolicy",
  applicableCountry: "ZA",
  returnPolicyCategory: "https://schema.org/MerchantReturnFiniteReturnWindow",
  merchantReturnDays: 7,
  returnMethod: "https://schema.org/ReturnByMail",
  returnFees: "https://schema.org/ReturnFeesCustomerResponsibility",
  customerRemorseReturnFees: "https://schema.org/ReturnFeesCustomerResponsibility",
  itemDefectReturnFees: "https://schema.org/FreeReturn",
};

// Hygiene-sensitive products: ordinary (change-of-mind) returns not permitted.
// Statutory defect/unsafe rights are preserved in the on-page policy text, not here.
const HYGIENE_RETURN_POLICY = {
  "@type": "MerchantReturnPolicy",
  applicableCountry: "ZA",
  returnPolicyCategory: "https://schema.org/MerchantReturnNotPermitted",
};

// Return-policy object for a product classification. Anything other than the
// explicit "hygiene_non_returnable" flag is treated as standard/returnable.
function returnPolicyFor(returnEligibility) {
  return returnEligibility === "hygiene_non_returnable"
    ? HYGIENE_RETURN_POLICY
    : STANDARD_RETURN_POLICY;
}

module.exports = {
  SHIPPING_DETAILS,
  STANDARD_RETURN_POLICY,
  HYGIENE_RETURN_POLICY,
  returnPolicyFor,
};
